// app/javascript/controllers/exclusive_recipients_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["select", "email", "submit"];

    connect() {
        this.onChange(); // set initial state
    }

    onChange() {
        const hasSelect = this.selectTarget?.value?.trim() !== "";
        const hasEmail  = (this.emailTarget?.value || "").trim() !== "";

        // If a group is chosen, disable the email input.
        this._setDisabled(this.emailTarget, hasSelect);
        if (hasSelect) this.emailTarget.value = ""; // keep it clean

        // If an email is typed, clear & disable the select.
        this._setDisabled(this.selectTarget, hasEmail);
        if (hasEmail && this.selectTarget.value !== "") this.selectTarget.value = "";

        // Button is always enabled here; final guard happens on submit.
    }

    validate(e) {
        const hasSelect = this.selectTarget?.value?.trim() !== "";
        const email     = (this.emailTarget?.value || "").trim();
        const hasValidEmail = email.length > 0 && this._isEmail(email);

        if (!hasSelect && !hasValidEmail) {
            e.preventDefault();
            this._flash("Please choose a recipient group or enter a valid email address.", "warning");
            this._focusFirst();
            return false;
        }
        // OK: allow form to submit
        return true;
    }

    // --- helpers ---
    _isEmail(v) {
        // Simple, friendly pattern
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
    }

    _setDisabled(el, disabled) {
        if (!el) return;
        el.disabled = !!disabled;
        el.classList.toggle("disabled", !!disabled);
    }

    _flash(msg, level = "warning") {
        const box = document.getElementById("ty-flash");
        if (!box) return;
        box.innerHTML = `
      <div class="alert alert-${level} alert-dismissible fade show" role="alert">
        ${msg}
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>`;
    }

    _focusFirst() {
        // Prefer email, otherwise the select
        if (!this.emailTarget.disabled) {
            this.emailTarget.focus();
        } else if (!this.selectTarget.disabled) {
            this.selectTarget.focus();
        }
    }
}